import React from 'react'
import PostVacanciesTable from './CommonVacanciesTable'


export default function SEPostVacancies() {
  return (
    <div>
        <PostVacanciesTable
      heading='Post Vacancies (School Education)' headerName='Post Vacancies (School Education)'
      urlParam='DISTS'
    />
    </div>
  )
}
